 
// import { Box, Button, Popover } from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
// import dayjs from 'dayjs';
// import { Dropdown } from 'react-bootstrap';
// import { useEffect, useState } from 'react';

// function DateRangeFilter({ selectedDateRange, handleDateRangeChange, setSelectedDateRange, label, type }) {
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [value, setValue] = useState([null, null]);

//     const handleOpen = (event) => setAnchorEl(event.currentTarget);
//     const handleClose = () => setAnchorEl(null);

//     const handleChange = (newValue) => { 
//         if (newValue[0] && newValue[1]) {
//             const startDate = newValue[0].$d.toString();
//             const endDate = newValue[1].$d.toString();
//             setValue(newValue);
//             setSelectedDateRange(newValue);  
//             handleDateRangeChange(newValue);
//         } else { 
//             setValue([null, null]);
//             setSelectedDateRange([null, null]);
//             handleDateRangeChange([null, null]);
//         }
//     }; 
//     useEffect(() => {
//         if (selectedDateRange[0] === null && selectedDateRange[1] === null) {
//             setValue([null, null]); // Reset local value when parent clears it
//         }
//     }, [selectedDateRange]);


//     return (
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <Box display="flex" alignItems="center">
//                 <Dropdown className={`d-inline-block ${type=="jobBoard" ? "form-control":""}`} variant="outlined" onClick={handleOpen}>
//                     {/* <Dropdown.Toggle className="p-0" id="statusFilterDropdown"> 
//                         {value[0] && value[1]
//                             ? `${dayjs(value[0]).format('MM/DD/YYYY')} - ${dayjs(value[1]).format('MM/DD/YYYY')}`
//                             : 'Date range '}
//                     </Dropdown.Toggle> */}
//                       <Dropdown.Toggle className="p-0" id="statusFilterDropdown"> 
//                         {
//                         // value[0] && value[1]
//                         //     ? `${new Date(value[0]).toLocaleDateString("en-US", {
//                         //           year: "numeric",
//                         //           month: "long",
//                         //           day: "numeric"
//                         //       })} - ${new Date(value[1]).toLocaleDateString("en-US", {
//                         //           year: "numeric",
//                         //           month: "long",
//                         //           day: "numeric"
//                         //       })}`
//                         //     : 
//                             label}
//                     </Dropdown.Toggle>
//                 </Dropdown>
//                 <Popover
//                     open={Boolean(anchorEl)}
//                     anchorEl={anchorEl}
//                     onClose={handleClose}
//                     anchorOrigin={{
//                         vertical: 'bottom',
//                         horizontal: 'left',
//                     }}
//                 >
//                     <DateRangePicker
//                         value={value}
//                         onChange={handleChange}
//                         localeText={{ start: 'Start Date', end: 'End Date' }}
//                     />
//                 </Popover>
//             </Box>
//         </LocalizationProvider>
//     );
// }

// export default DateRangeFilter;

import React, { useState, useEffect } from "react";
import { DatePicker, Button } from "antd";
import dayjs from "dayjs";
import { Dropdown } from "react-bootstrap";

const { RangePicker } = DatePicker;

function DateRangeFilter({
  selectedDateRange,
  handleDateRangeChange,
  setSelectedDateRange,
  label,
  type,
}) {
  const [selectedRange, setSelectedRange] = useState([null, null]);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open) => {
    setIsOpen(open);
  };

  const handleRangeChange = (dates) => {
    if (dates) {
      const formattedDates = [
        dates[0].format("YYYY-MM-DD"),
        dates[1].format("YYYY-MM-DD"),
      ];

      setSelectedDateRange(formattedDates);
      setSelectedRange(formattedDates);
      handleDateRangeChange(formattedDates); // Callback for parent component
    } else {
      setSelectedDateRange([null, null]);
      setSelectedRange([null, null]);
      handleDateRangeChange([null, null]); // Clear parent data
    }
  };

  useEffect(() => {
    if (
      selectedDateRange[0] === null &&
      selectedDateRange[1] === null
    ) {
      setSelectedRange([null, null]); // Reset local value when parent clears it
    }
  }, [selectedDateRange]);

  return (
    <div className={`dateRanegeFilter ${type==='jobBoard'? "" : ""}`} style={{ display: "flex", alignItems: "center" }}>
      <Dropdown.Toggle
       className={`p-0 ${type ==='jobBoard'? "navbar-drop-buttons" : ''} `} 
       variant={type === 'jobBoard' ? "secondary" : "primary"}
        onClick={() => setIsOpen(!isOpen)}
        id="dropdown-basic"
        //statusFilterDropdown
      >
        {/* {selectedRange[0] && selectedRange[1]
          ? `${selectedRange[0]} to ${selectedRange[1]}`
          :  */}
          {label}
{/*           
          || "Select Date Range"} */}
      </Dropdown.Toggle>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            background: "#fff",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            padding: "10px",
          }}
        >
          <RangePicker
            value={
              selectedRange[0] && selectedRange[1]
                ? [dayjs(selectedRange[0]), dayjs(selectedRange[1])]
                : null
            }
            onChange={handleRangeChange}
            open={isOpen}
            onOpenChange={handleOpenChange}
            style={{ width: 300 }}
            format="YYYY-MM-DD"
          />
        </div>
      )}
    </div>
  );
}

export default DateRangeFilter;
